<template>

  <div class="content">
    <img
        class="back"
        @click="goHome"
        v-lazy="require('./../../../assets/img/back.png')"
      />
    <div class="head">
      <div
        @click.stop="openEr()"
        style="
          position: absolute;
          right: 12px;
          top: 10px;
          font-size: 13px;
          z-index: 100;
          color: #fff;
          border-radius: 5px;
          padding: 3px;
          font-family: SourceHanSansCN-Regular, SourceHanSansCN;
          font-weight: 400;
          color: #ffffff;
        "
      >
        <img
          style="
            height: 24px;
            width: 24px;
            vertical-align: middle;
            margin-top: -2px;
          "
          v-lazy="require('./../../../assets/img/test/kefu.png')"
        />
        <div style="display: inline-block; margin-left: 5px">提现咨询</div>
      </div>
      <div class="t1">累计收入</div>
      <div class="t2">{{ info.cashed }}</div>
      <div class="t3" @click="goDetail">提现</div>
      <div class="t4">余额{{ info.to_cash }}元</div>
    </div>
    <van-popup v-model="showEr" style="top: 7.5rem" @close="closeEr()" round>
      <div class="pop" style="padding: 37px 28px">
        <div
          style="
            padding-bottom: 27px;
            background: #fff;
            border-radius: 35px;
            padding: 15px;
          "
        >
          <img
            v-lazy="showPop.image"
            style="width: 6.8rem; height: auto"
            class="pop-img"
          />
          <div style="text-align: center">识别二维码，添加客服微信</div>
        </div>
      </div>
      <div style="text-align: center">
        <img
          style="height: 30px; width: 30px; margin: 28px auto"
          @click="showEr = false"
          class="closeImg"
          v-lazy="closeImg"
        />
      </div>
    </van-popup>
    <div class="menu">
      <div class="list" @click="active = !active">
        收益订单
        <img
          v-if="active"
          style="
            width: 10px;
            height: 10px;
            margin-left: 1px;
            float: right;
            vertical-align: middle;
            margin-top: 5px;
          "
          v-lazy="require('../../../assets/img/test/goldright.png')"
        />
        <img
          v-else
          style="
            width: 10px;
            height: 10px;
            margin-left: 1px;
            float: right;
            vertical-align: middle;
            margin-top: 5px;
          "
          v-lazy="require('../../../assets/img/test/golddown.png')"
        />
      </div>

      <ul :class="active ? 'activ' : 'noactiv'">
        <li class="li" v-for="item in cashList" :key="item">
          <div class="li1">
            {{ item.buy_name }} <span>+{{ item.buy_amount }}</span>
          </div>
          <div class="li2">
            {{ item.updated_at.split(" ")[0] }}<span>{{ state_name }}</span>
          </div>
        </li>
        <!-- <li class='li'>
                <div class='li1'>测评的名字 <span>+12.80</span></div>
                <div class='li2'>2021-04-18<span>已结算</span></div>
            </li>
            <li class='li'>
                <div class='li1'>测评的名字 <span>+12.80</span></div>
                <div class='li2'>2021-04-18<span>已提现</span></div>
            </li> -->
      </ul>
    </div>
    <div class="menu">
      <div class="list" @click="active1 = !active1">
        提现记录
        <img
          v-if="active1"
          style="
            width: 10px;
            height: 10px;
            margin-left: 1px;
            float: right;
            vertical-align: middle;
            margin-top: 5px;
          "
          v-lazy="require('../../../assets/img/test/goldright.png')"
        />
        <img
          v-else
          style="
            width: 10px;
            height: 10px;
            margin-left: 1px;
            float: right;
            vertical-align: middle;
            margin-top: 5px;
          "
          v-lazy="require('../../../assets/img/test/golddown.png')"
        />
      </div>

      <ul
        :style="
          active1
            ? 'max-height: 0;transition: max-height 0.25s ease-out; overflow: hidden;'
            : 'max-height:5000px;transition:max-height 0.5s ease-in;'
        "
      >
        <li class="li" v-for="item in csList" :key="item">
          <div class="li1">
            提现{{ item.amount }}元 <span>{{ item.is_payed_name }}</span>
          </div>
          <div class="li2">{{ item.created_at.split(" ")[0] }}</div>
        </li>
        <!-- <li class='li'>
                <div class='li1'>提现12.80元 <span>提现成功</span></div>
                <div class='li2'>2021-04-18<span>到账12.06元，微信扣除手续费0.74元</span></div>
            </li>
            <li class='li'>
                <div class='li1'>提现12.80元 <span>提现成功</span></div>
                <div class='li2'>2021-04-18<span>到账12.06元，微信扣除手续费0.74元</span></div>
            </li> -->
      </ul>
    </div>
    <div class="menu">
      <div class="list" @click="goDes">
        奖励秘籍
        <img
          style="
            width: 10px;
            height: 10px;
            margin-left: 1px;
            float: right;
            vertical-align: middle;
            margin-top: 5px;
          "
          v-lazy="require('../../../assets/img/test/goldright.png')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { goldInfo, goldOrder, goldCash } from "@/http/api";
export default {
  name: "gold",
  data() {
    return {
      active: true,
      showEr: false,
      active1: true,
      info: {},
      cashList: [],
      csList: [],
      showPop: {
        image: require("./../../../assets/img/test/erweima.png"),
      },
      closeImg: require("./../../../assets/img/test/close.png"),
      logo: require("./../../../assets/img/logos.png"),
    };
  },
  created() {
    goldInfo().then((res) => {
      this.info = res.data;
    });
    goldOrder().then((res) => {
      this.cashList = res.data;
    });
    goldCash().then((res) => {
      this.csList = res.data.objects || [];
    });
  },
  methods: {
     goHome() {
      this.$router.push("/my/center");
    },
    // 进入主页
    closeEr() {
      this.showEr = false;
    },
    openEr() {
      this.showEr = true;
    },
    goDetail() {
      this.$router.push("./golddetail");
    },
    goDes() {
      this.$router.push("./goldDes");
    },
  },
};
</script>

<style lang="less" scoped>
@import "~Style/index.less";
.back {
  width: 22px;
  height: 23px;
  background-repeat: no-repeat;
  background-size: contain;
  position: absolute;
  left: 20px;
  top: 20px;
  z-index: 10;
}
.content {
  .head {
    height: 61.3vw;
    width: 100vw;
    background-image: url("./../../../assets/img/test/goldback.png");
    background-repeat: no-repeat;
    background-size: contain;
    text-align: center;
    padding-top: 34px;
    position: relative;

    .t1 {
      font-size: 18px;
      font-family: SourceHanSansCN-Medium, SourceHanSansCN;
      font-weight: 500;
      color: #ffffff;
    }

    .t2 {
      font-size: 52px;
      font-family: SourceHanSansCN-Bold, SourceHanSansCN;
      font-weight: bold;
      color: #ffffff;
      margin-top: 22px;
    }

    .t3 {
      width: 205px;
      height: 39px;
      background: #ffffff;
      border-radius: 18px;
      font-size: 18px;
      font-family: SourceHanSansCN-Medium, SourceHanSansCN;
      font-weight: 500;
      color: #4a4a4a;
      margin: 0 auto;
      margin-top: 21px;
      line-height: 39px;
    }

    .t4 {
      font-size: 15px;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      font-weight: 400;
      color: #ffffff;
      margin-top: 11px;
    }
  }

  // .pop1 {
  //     margin-top: -17px;
  //     border-radius: 24px;
  //     width: 8.14rem;

  //     .tt {
  //         margin-top: 30px;
  //         width: 90%;
  //         margin-left: 5%;
  //     }

  //     // .pop-img1 {

  //     //     // border-radius: 0.5rem;
  //     // }

  //     .pop-title {
  //         text-align: center;
  //         font-size: 18px;
  //         font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  //         font-weight: 500;
  //         color: #4A4A4A;
  //         padding-bottom: 23px;
  //         padding: 33px;
  //         background: #fff;
  //     }

  //     .pop-exc {
  //         padding: 0 27px;
  //         text-align: center;
  //         font-size: 15px;
  //         font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  //         font-weight: 400;
  //         color: #4A4A4A;
  //         // line-height: 0.41rem;
  //         letter-spacing: 1px;
  //         background: #fff;
  //         padding-bottom: 75px;
  //     }

  //     .pop-imglist {
  //         text-align: center;
  //         margin-bottom: 0.25rem;
  //         padding-bottom: 44px;

  //         img {
  //             height: 0.92rem;
  //             width: 0.87rem;
  //         }
  //     }

  //     .closeImg {
  //         height: 30px;
  //         width: 30px;
  //         margin: 0 auto;
  //     }

  //     .popFt {
  //         text-align: center;
  //         margin-top: -34px;

  //         margin-bottom: 20px;

  //         .popbtn {
  //             width: 80%;
  //             background-color: #42686E;
  //             font-weight: bold;
  //             color: white;
  //             border-radius: 0.5rem;
  //             border: none;
  //         }

  //         .getCoupon {
  //             background-color: #42686E;
  //         }

  //         .rightIcon {
  //             width: 20px;
  //             height: 20px;
  //             display: inline-block;
  //             background-color: green;
  //             border-radius: 10px;
  //             color: white;
  //             margin-left: 10px;
  //         }
  //     }

  //     .popbtn {
  //         width: 80%;
  //         // margin-left: 10%;
  //         // font-weight: bold;
  //         font-size: 18px;
  //         color: white;
  //         border-radius: 0.5rem;
  //     }

  //     .reduce {
  //         display: inline-block;
  //         background: url("./../../../assets/img/test/reduce.png") no-repeat center center;
  //         background-size: 100%, 100%;
  //         width: 25px;
  //         height: 25px;
  //     }

  //     .reduce-1 {
  //         display: inline-block;
  //         background: url("./../../../assets/img/test/reduce-1.png") no-repeat center center;
  //         background-size: 100%, 100%;
  //         width: 25px;
  //         height: 25px;
  //     }

  //     .number {
  //         vertical-align: super;
  //         margin-top: -10px;
  //         display: inline-block;
  //         padding: 5px;
  //     }

  //     .add {
  //         display: inline-block;
  //         background: url("./../../../assets/img/test/add.jpg") no-repeat center center;
  //         background-size: 100%, 100%;
  //         width: 25px;
  //         height: 25px;
  //     }

  //     img {
  //         width: 8.8rem;
  //         height: 7rem;
  //         border-radius: 0.5rem;
  //     }

  //     .code {
  //         margin: 10px auto 0;
  //         text-align: center;
  //         font-weight: bold;
  //         line-height: 47px;
  //         letter-spacing: 1.33px;
  //         .w(237);
  //         height: 47px;
  //         background-color: #eceff5;
  //         border-radius: 18px;
  //         font-size: 24px;
  //         font-weight: bold;
  //     }

  //     .rightIcon {
  //         width: 20px;
  //         height: 20px;
  //         background-color: green;
  //         border-radius: 10px;
  //         color: white;
  //         position: absolute;
  //         top: 50%;
  //         right: 23px;
  //         transform: translateY(-50%);
  //         line-height: 20px;
  //     }
  // }

  .menu {
    .activ {
      max-height: 0;
      transition: max-height 0.5s;
      overflow: hidden;
    }

    .noactiv {
      max-height: 1000px;
    }

    .list {
      padding: 30px 15px;
      border-bottom: 1px solid #eaeaea;
    }

    .li {
      padding: 15px 16px;
      border-bottom: 1px solid #eaeaea;
      background: #f3f7f7;

      .li1 {
        margin-bottom: 11px;
        font-size: 15px;
        font-family: SourceHanSansCN-Normal, SourceHanSansCN;
        font-weight: 400;
        color: #000000;

        span {
          font-size: 15px;
          font-family: SourceHanSansCN-Normal, SourceHanSansCN;
          font-weight: 400;
          color: #417505;
          float: right;
        }
      }

      .li2 {
        font-size: 13px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #9b9b9b;

        span {
          font-size: 13px;
          font-family: SourceHanSansCN-Regular, SourceHanSansCN;
          font-weight: 400;
          color: #9b9b9b;
          float: right;
        }
      }
    }
  }
}
</style>
